"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserInfo = void 0;
const react_1 = __importDefault(require("react"));
const common_1 = require("../../../common");
const StatisticsList_1 = require("./StatisticsList");
const server_1 = require("../../../server");
exports.UserInfo = react_1.default.memo(({ id }) => {
    const [userInfo, setUserInfo] = react_1.default.useState([]);
    const { data, refetch } = (0, server_1.useMemberInfo)({
        ...(id ? { id } : {}),
        orderby: ['level ASC', 'id'],
        with_more_info: true,
    });
    react_1.default.useEffect(() => {
        refetch();
    }, [id]);
    react_1.default.useEffect(() => {
        if (data) {
            const { total_count, items, found_count } = data;
            if (total_count > 0 && found_count === 0) {
                // 단건성 조회에서 서버 total_count·items 불일치 응답 시 기존에 로드된
                // 사용자 정보가 지워지지 않도록 현재 상태를 유지한다(정상 빈 응답은 total_count 0으로 아래에서 처리).
                return;
            }
            else {
                if (items.length > 0) {
                    setUserInfo(items);
                    return;
                }
            }
        }
        setUserInfo([]);
    }, [data]);
    const handleDownload = async () => {
        APP.eventManager.publish('SHOW_LOADING', true);
        try {
            const response = await fetch(`/api/mimac/v1/members/${id}/download-report`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            if (!response.ok) {
                throw new Error('Failed to fetch the report');
            }
            const blob = await response.blob();
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `${userInfo[0].nickname} 통계.xlsx`;
            link.click();
        }
        catch (error) {
            console.error('Error downloading the report:', error);
        }
        APP.eventManager.publish('SHOW_LOADING', false);
    };
    return (react_1.default.createElement("div", { className: "admin-detail-info" },
        react_1.default.createElement("div", { className: "admin-title" },
            react_1.default.createElement("div", { className: "admin-title-left" },
                react_1.default.createElement("p", null, "\uC0AC\uC6A9\uC790 \uC815\uBCF4")),
            react_1.default.createElement("div", { className: "admin-title-right" },
                react_1.default.createElement(common_1.Button, { className: "btn btn-dark-grey btn-xmd btn-semi-round", text: "common.download", onClick: handleDownload }))),
        react_1.default.createElement(StatisticsList_1.StatisticsList, { onlyOne: true, searchOption: "", initPage: 0, id: id })));
});
